import {Component, HostBinding, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Subject, Subscription } from 'rxjs';
import { ConfirmPopupComponent } from 'src/app/components';
import { ReportPageConstant } from 'src/app/constants/reportPage.constants';
import { ReportPageInterface } from 'src/app/interface';
import { FieldValue, FieldValueReset, Ownership, Report } from 'src/app/model';
import { FooterButtonOption, PageNumbers } from 'src/app/model/Enums';
import { ReportProvider } from 'src/app/providers';
import {CommonService, ReportService, ToasterService} from 'src/app/services';
import { radioGroupOption } from '../../commonModel/common-classes';
import {ValueWarningPopupComponent} from '../../components/value-warning-popup/value-warning-popup.component';
import {routeTransition} from '../../../../animations/route-transition';

@Component({
  selector: 'app-ownership',
  templateUrl: './ownership.component.html',
  styleUrls: ['./ownership.component.scss'],
  animations: [routeTransition],
})
export class OwnershipComponent implements OnInit, OnDestroy, ReportPageInterface {
  @HostBinding('@routeTransition') routeAnimation = true;
  public currentReport: Report;
  private reportSub: Subscription;
  reportPageConst = ReportPageConstant;

  //#region "location-amount"
  ownershipSize: number = this.common.isTabletDevice || this.common.isMobileDevice ? 3 : 10;
  selectedOwnerLength: number = 0;
  isEnterMore: boolean = false;
  ownerList: radioGroupOption[] = [];
  //#endregion

  //#region "location-details"
  @ViewChild("ownerForm") ownerForm: NgForm;
  selectedOwner = new Ownership();
  private shadowOwnerName: string;
  //#endregion

  constructor(
    public reportService: ReportService,
    private reportProvider: ReportProvider,
    private modalService: BsModalService,
    private router: Router,
    private toastr: ToasterService,
    private common: CommonService,
  ) { }

  ngOnInit(): void {

    for (let i = 1; i <= this.ownershipSize; i++) {
      const optObject = new radioGroupOption();
      optObject.title = i.toString();
      optObject.value = i;
      this.ownerList.push(optObject);
    }

    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;

      if (this.currentReport) {
        if (this.currentReport.LATEST.OWNERSHIP_LIST.length) {
          this.currentReport.LATEST.OWNERSHIP_LIST.sort((a, b) => Number(a.ORDER) - Number(b.ORDER));
          this.selectOwner(this.currentReport.LATEST.OWNERSHIP_LIST[0]);
        } else {
          if (!this.selectedOwner.ID)
            this.checkSelectedOwner();
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  //#region "location-amount"
  /**
   * @description for create selected no. of owners
   */
  ownerSelection() {
    if (!this.currentReport.LATEST.OWNERSHIP_LIST.length) {
      if (this.selectedOwnerLength) {
        this.toastr.info('We are preparing owners, please wait a moment.');
        this.reportProvider.addDefaultOwner(this.currentReport.LATEST.ID, this.selectedOwnerLength).subscribe(resp => {
          if (resp.success) {
            this.currentReport.LATEST.OWNERSHIP_LIST = resp.result;
            this.currentReport.LATEST.OWNERSHIP_LIST.sort((a, b) => Number(a.ORDER) - Number(b.ORDER));
            for (let i = 0; i < this.currentReport?.LATEST?.OWNERSHIP_LIST?.length; i++) {
              const element = this.currentReport.LATEST.OWNERSHIP_LIST[i];
              element.NAME = 'Owner ' + (i + 1);
            }
            if (this.currentReport.LATEST.OWNERSHIP_LIST.length) {
              this.selectOwner(this.currentReport.LATEST.OWNERSHIP_LIST[0]);
            }
          } else {
            this.toastr.error(resp.error.txt);
          }
        }, err => {
          // Error Handling
        });
      } else {
        if (this.reportSub)
          this.reportSub.unsubscribe();
      }
    }
  }
  //#endregion

  //#region "owner-details"
  checkSelectedOwner() {
    if (!this.selectedOwner.ID) {
      setTimeout(() => {
        if (this.currentReport.LATEST.OWNERSHIP_LIST.length) {
          this.selectOwner(this.currentReport.LATEST.OWNERSHIP_LIST[0]);
        } else {
          this.checkSelectedOwner();
        }
      }, 500);
    }
  }

  /**
   * @description create/add new owner
   */
  addBlankOwner() {
    let newOwnernName = '';
    const regexp = new RegExp('Owner\\s(\\d+)\\b');
    const numberArray = this.currentReport.LATEST.OWNERSHIP_LIST.filter(({ NAME }) => regexp.test(NAME)).map(el => Number(el.NAME.match(/\d+/g)));
    if (numberArray.length) {
      newOwnernName = 'Owner ' + Number(Math.max(...numberArray) + 1);
    } else {
      newOwnernName = 'Owner 1';
    }

    this.toastr.info('Please wait a moment!');
    let owner = new Ownership();
    owner.NAME = newOwnernName;
    this.selectedOwner = owner;
    this.reportProvider.saveOwner(this.currentReport.LATEST.ID, this.selectedOwner).subscribe(resp => {
      if (resp.success) {
        this.selectedOwner = resp.result;
        this.currentReport.LATEST.OWNERSHIP_LIST.push(resp.result);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for select owner
   * @param owner selected owner
   */
  selectOwner(owner: Ownership) {
    owner.PERCENT = owner.PERCENT > 0 ? owner.PERCENT : null;
    this.selectedOwner = owner;
  }

  focusOwnerName(): void {
    if (!this.selectedOwner.DISPLAY_NAME){
      this.shadowOwnerName = this.selectedOwner.NAME;
      this.selectedOwner.NAME = "";
    }
  }

  makeDefaultName(): void {
    if (this.shadowOwnerName){
      this.selectedOwner.NAME = this.shadowOwnerName;
    } else this.shadowOwnerName = null;

    if (this.selectedOwner.DISPLAY_NAME.trim() == this.selectedOwner.NAME.trim()) {
      this.selectedOwner.DISPLAY_NAME = '';
    }

    setTimeout(() => {
      this.callUpdateAPI('DISPLAY_NAME');
    }, 10);
  }

  /**
   * @description field update API
   * @param fieldName field name which we want to update
   */
  callUpdateAPI(fieldName: string) {

    setTimeout(() => {
      this.autoScroll(fieldName);
    }, 10);

    const isManagerSalary = this.reportService.showOwnershipSalary() == 1 ? true : false;
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'OWNERSHIP';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = fieldName == 'PERCENT' ? parseFloat(this.selectedOwner[fieldName]?.toString() || '0') : this.selectedOwner[fieldName];
    this.reportProvider.updateReportField(this.selectedOwner.ID, objFieldValue).subscribe(res => {
      if (res.success) {
        if ((this.currentReport.LATEST.MAX_STAGE > PageNumbers.MANAGER_SALARY || this.currentReport.LATEST.MAX_STAGE > PageNumbers.REPLACEMENT_SALARY)
          && fieldName == 'HOURS' && res?.result?.newValue) {
          this.updateSalaryPage(isManagerSalary);
        }
      } else {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  autoScroll(fieldName: string) {
    switch (fieldName) {
      case 'NAME':
        this.reportService.makeElementFocus('ownership-check-percentage');
        break;
      case 'PERCENT':
        if (!document?.activeElement?.id || document?.activeElement?.id !== 'ownership-selected-owner') {
          this.reportService.makeElementFocus('ownership-working-hours');
        }
        break;
    }
  }

  updateSalaryPage(isManagerSalary: boolean) {
    if (isManagerSalary) {
      this.reportService.updateMaxStage(PageNumbers.MANAGER_SALARY, true);
      this.reportService.addInvalidStage(PageNumbers.MANAGER_SALARY, false, false);
    } else {
      this.updateReplacementSalaryFields();
      this.reportService.updateMaxStage(PageNumbers.REPLACEMENT_SALARY, true);
      this.reportService.addInvalidStage(PageNumbers.REPLACEMENT_SALARY, false, false);
    }
  }

  /**
   * @description for reopen wizard popup
   */
  updateReplacementSalaryFields() {
    let objFieldValue = new FieldValueReset();
    objFieldValue.GROUP = 'REPORT_VERSION';
    objFieldValue.FIELD_LIST = ['ASSISTED_REPLACEMENT_SALARY'];
    this.reportProvider.resetReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (res.success) {
        this.currentReport.LATEST.ASSISTED_REPLACEMENT_SALARY = null;
      } else {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description for delete owner
   * @param ownerId primary key for delete owner
   * @param index index for owner
   */
  deleteOwner(ownerId, index) {

    let confirmModalRef: BsModalRef;
    confirmModalRef = this.modalService.show(ConfirmPopupComponent, Object.assign({
      initialState: {
        message: 'Do you want to delete owner?'
      }
    }, { class: 'modal-sm modal-dialog-centered' }));

    const ackSubject = new Subject<boolean>();
    confirmModalRef.content.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value) {
        const isManagerSalary = this.reportService.showOwnershipSalary() == 1 ? true : false;
        if (this.currentReport.LATEST.MAX_STAGE >= PageNumbers.MANAGER_SALARY || this.currentReport.LATEST.MAX_STAGE >= PageNumbers.REPLACEMENT_SALARY) {
          this.updateSalaryPage(isManagerSalary);
        }

        this.reportProvider.deleteOwner(this.currentReport.LATEST.ID, ownerId).subscribe(response => {
          if (response.success) {
            this.currentReport.LATEST.OWNERSHIP_LIST.splice(index, 1);
            this.toastr.success('Owner deleted successfully!')
            if (index === 0) {
              this.selectedOwner = this.currentReport.LATEST.OWNERSHIP_LIST[0];
            } else {
              this.selectedOwner = this.currentReport.LATEST.OWNERSHIP_LIST[index - 1];
            }
          }
        }, err => {
          // Error Handling
        });

      }
    });
  }

  /**
   * @description check seleted owner is entered in DB or not
   */
  addOwnerDisabled() {
    return this.currentReport.LATEST.OWNERSHIP_LIST.some(el => !el.ID);
  }

  /**
   * @description check percentage total
   * @returns percentage total is 100 or not
   */
  checkPercentage(): boolean {
    if (this.currentReport.LATEST.OWNERSHIP_LIST.reduce((summ, v) => (summ += Number(v.PERCENT) || 0), 0) <= 100) {
      return true;
    } else {
      this.toastr.error('The sum of the percentage of ownership for all owners greater than 100%!');
      return false;
    }
  }

  /**
   * @description check entered hours for all owners
   * @returns hours is not more then 168
   */
  checkHours(): boolean {
    if (!this.currentReport.LATEST.OWNERSHIP_LIST.some(el => Number(el.HOURS) > 168)) {
      return true;
    } else {
      this.toastr.error('The Hours Worked Per Week not allowed more ther 168 hours!');
      return false;
    }
  }

  /**
   * @description check all added owner required fields are valid
   * @returns all added owner valid or not
   */
  checkRequiredValidation(): boolean {
    if (this.currentReport?.LATEST)
      return !this.currentReport.LATEST.OWNERSHIP_LIST.some(el => el.HOURS == null || el.HOURS == undefined || el.HOURS.toString() == '');
    else
      return true;
  }
  //#endregion

  /**
   * @description function call at the time of footer button click, for switch route or owner
   */
  switchNextOwner() {
    const currentOwnerIndex = this.currentReport.LATEST.OWNERSHIP_LIST.findIndex(onr => onr.ID == this.selectedOwner.ID);
    if (currentOwnerIndex === this.currentReport.LATEST.OWNERSHIP_LIST.length - 1) {
      if (this.checkRequiredValidation()) {
        if (this.checkPercentage() && this.checkHours()) {
          // comment for alternative flow
          // this.reportService.updateMaxStage(PageNumbers.OWNER_DETAILS);
          // this.router.navigateByUrl(`/report/${this.currentReport.ID}/income/year-end`);
          this.reportService.updateMaxStage(PageNumbers.OWNERSHIP);
          this.router.navigateByUrl(`/report/${this.currentReport.ID}/income`);
        }
      } else {
        this.toastr.error("Please fill all required fields of all added owners !")
      }
    } else if (currentOwnerIndex < this.currentReport.LATEST.OWNERSHIP_LIST.length - 1) {
      this.selectOwner(this.currentReport.LATEST.OWNERSHIP_LIST[currentOwnerIndex + 1]);
    }
  }

  /**
   * @description function call at the time of footer button click, for switch route or owner
   */
  switchBackOwner() {
    const currentOwnerIndex = this.currentReport.LATEST.OWNERSHIP_LIST.findIndex(onr => onr.ID == this.selectedOwner.ID);
    if (currentOwnerIndex <= 0) {
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/location`);
    } else if (currentOwnerIndex > 0) {
      this.selectOwner(this.currentReport.LATEST.OWNERSHIP_LIST[currentOwnerIndex - 1]);
    }
  }

  /**
   * @description function of interface for validation
   * @returns form valid or not
   */
  isFormValid(): boolean {
    return this.checkRequiredValidation();
  }

  /**
   * @description function of interface for skip functionality
   * @returns form can be skippable or not
   */
  canBeSkipped(): boolean {
    return true;
  }

  /**
   * @description report footer button click options
   * @param buttonOption which button clicked by user
   */
  footerButtonClick(buttonOption: number) {
    if (buttonOption == FooterButtonOption.NEXT_CLICK) {
      if (this.reportService.showOwnerAmountPage()) {
        if (this.selectedOwnerLength) {
          this.ownerSelection();
        } else {
          // comment for alternative flow
          // this.router.navigateByUrl(`/report/${this.currentReport.ID}/income/year-end`);
          this.router.navigateByUrl(`/report/${this.currentReport.ID}/income`);
        }
      } else {
        if (document.getElementById('reportPart')) {
          document.getElementById('reportPart').scrollTo(0, 0);
        }
        this.switchNextOwner();
      }
    } else if (buttonOption == FooterButtonOption.BACK_CLICK) {
      if (document.getElementById('reportPart')) {
        document.getElementById('reportPart').scrollTo(0, 0);
      }
      this.switchBackOwner();
    } else if (buttonOption == FooterButtonOption.SKIP_CLICK) {
      // comment for alternative flow
      // this.reportService.updateMaxStage(PageNumbers.OWNER_DETAILS);
      // this.router.navigateByUrl(`/report/${this.currentReport.ID}/income/year-end`);
      this.reportService.updateMaxStage(PageNumbers.OWNERSHIP);
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/income`);
    }
  }

  /**
   * to open tax return info
   * */
  openTaxReturnInfoModel() {
    this.modalService.show(ValueWarningPopupComponent, Object.assign({
      initialState: {
        title: 'Ownership Information',
        message: 'To find ownership information on your tax return, refer to the following sections:\n' +
          '  <ul>\n' +
          '    <li>For C Corps, on Form 1120 check Schedule G for details on individuals or entities owning 20% or more of the corporation’s voting stock AND review your formation documents for ownership to confirm owners of less than 20% of stock.</li>\n' +
          '    <li>For S Corps, on Form 1120S look at Schedule K-1, which shows each shareholder’s percentage of ownership.</li>\n' +
          '    <li>For LLCs or Partnerships, on Form 1065 ownership information is included in Schedule K-1, detailing each partner’s share.</li>\n' +
          '    <li>For Sole Proprietorships, on Form 1040 - Schedule C  ownership is inherently tied to the individual filing the return.  Sole Proprietorships should only have a single owner.</li>\n' +
          '  </ul>',
        showInnerHtml: true
      }
    }, { class: 'modal-lg modal-dialog-centered' }));
  }

}
